export default __webpack_public_path__ + "static/media/phonebg2.f542edb1.svg";